module.exports = __webpack_public_path__ + "static/img/21map3.577a105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/21map3.png
// module id = o2MA
// module chunks = 0